import * as React from 'react';
import Context from '../State/Context';
import ButtonGray from './ButtonGray';
import { Reload } from './Icons';
import Tooltip from './Tooltip';

interface IButtonStartOverProps {
    showTooltip?: boolean,
    showDescription?: boolean,
    onReset: () => void,
}

export default ({ showDescription, showTooltip, onReset }: IButtonStartOverProps) => (
    <Context.Consumer>
        {
            ({ messages }) => (
                <React.Fragment>
                    <ButtonGray onClick={onReset}>
                        <Reload /> {messages.buttonStartOver}
                    </ButtonGray>
                    {showTooltip && <Tooltip text={messages.buttonStartOverTooltip} position="right"/>}
                    {showDescription && <span className="startOverDescription">{messages.buttonStartOverTooltip}</span>}
                </React.Fragment>
            )
        }
    </Context.Consumer>
);


// WEBPACK FOOTER //
// ./src/Components/ButtonStartOver.tsx